import React, { useEffect, useState, createElement } from 'react';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { Solution } from './components/Solution';
import { ProductShowcase } from './components/ProductShowcase';
import { Features } from './components/Features';
import { Bonuses } from './components/Bonuses';
import { Audience } from './components/Audience';
import { Pricing } from './components/Pricing';
import { ReviewsCarousel } from './components/ReviewsCarousel';
import { AboutCreator } from './components/AboutCreator';
import { Sparkles, Heart, Clock } from 'lucide-react';
// Declare fbq for TypeScript
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function App() {
  const [navTimeLeft, setNavTimeLeft] = useState(15 * 60);
  useEffect(() => {
    if (navTimeLeft <= 0) return;
    const timer = setInterval(() => {
      setNavTimeLeft(prev => prev <= 1 ? 0 : prev - 1);
    }, 1000);
    return () => clearInterval(timer);
  }, [navTimeLeft]);
  const navMinutes = Math.floor(navTimeLeft / 60).toString().padStart(2, '0');
  const navSeconds = (navTimeLeft % 60).toString().padStart(2, '0');
  useEffect(() => {
    // Meta Pixel initialization
    ;
    (function (f: any, b: Document, e: string, v: string, n?: any, t?: HTMLScriptElement, s?: Element) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e) as HTMLScriptElement;
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s?.parentNode?.insertBefore(t, s);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    // Initialize pixel and track PageView
    window.fbq('init', '676572141744167');
    window.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-[#FFFDF5] text-gray-900" data-id="element-0">
      {/* Meta Pixel noscript fallback */}
      <noscript data-id="element-1">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=676572141744167&ev=PageView&noscript=1" alt="" data-id="element-2" />
      </noscript>

      <main data-id="element-3">
        <Hero data-id="element-4" />
        <PainPoints data-id="element-5" />
        <Solution data-id="element-6" />
        <ProductShowcase data-id="element-7" />
        <Features data-id="element-8" />
        <Bonuses data-id="element-9" />
        <Audience data-id="element-10" />
        <Pricing data-id="element-11" />
        <ReviewsCarousel data-id="element-12" />
        <AboutCreator data-id="element-13" />
      </main>

      <footer className="bg-white py-10 border-t border-gray-100" data-id="element-14">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-15">
          <div className="flex items-center justify-center gap-2 mb-4" data-id="element-16">
            <Sparkles className="w-5 h-5 text-[#F5C842]" data-id="element-17" />
            <span className="text-lg font-bold" data-id="element-18">
              <span className="text-[#4AAAA5]" data-id="element-19">Crianza</span>
              <span className="text-[#E8845F]" data-id="element-20">Feliz</span>
            </span>
          </div>
          <p className="text-gray-400 text-sm" data-id="element-21">
            © {new Date().getFullYear()} Crianza Feliz. Todos los derechos
            reservados.
          </p>
          <p className="text-gray-400 text-xs mt-2" data-id="element-22">
            Este producto es digital. No se enviará ningún producto físico.
          </p>
        </div>
      </footer>
    </div>;
}